import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/job/getters";
import { actions } from "@/store/modules/job/actions";
import { mutations } from "@/store/modules/job/mutations";
import { IJobState, state } from "@/store/modules/job/state";

export const job: Module<IJobState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
